<template>
    <div class="medical-records h-100">
        <div class="row diet-section">
            <div class="col-12 mb-3">
                <div class="mobScroll">
                    <ul class="nav nav-tabs noWrap mb-0" role="tablist">
                        <li class="nav-item pl-0"> <a class="nav-link active" data-toggle="tab" href="#wearable"
                                role="tab">Wearable Analysis</a> </li>
                        <li class="nav-item"> <a class="nav-link " data-toggle="tab" href="#tracker" role="tab">Health
                                Tracker</a>
                        </li>
                        <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#orders" role="tab">Your Orders</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row mb-4 food-section Wearable-section">
            <div class="col-12">
                <div class="card border-0 ">
                    <div class="card-body bg-white border-radius-5 p-0">
                        <!-- Tab panes -->
                        <div class="tab-content">
                            <div class="tab-pane active" id="wearable" role="tabpanel">
                                <div class="row no-gutters">
                                    <div
                                        class="d-flex justify-content-between align-items-center col-md-12 Wearable-Data p-4">
                                        <div class="d-flex align-items-center">
                                            <figure class="mb-0 pr-3"><img src="../../../../static/website/images/user.svg" alt=""></figure>
                                            <div class="user-info">
                                                <h4 class="mb-0">02:30 hours spent <a href="#">See Time Logs</a> </h4>
                                                <h3 class="mb-0">Natty Virk</h3>
                                                <h4 class="mb-0">34 Years | Male</h4>
                                            </div>
                                        </div>
                                        <div class="Vital-Logs"><a href="#" class="btn btn-vital">Vital Logs</a></div>
                                    </div>
                                </div>
                                <div class="row no-gutters">
                                    <div class="col-md-12 border-top border-bottom Wearable-Details">
                                        <div class="row no-gutters">
                                            <div class="col p-4 Wearable-info border-right ">
                                                <a href="#">
                                                    <h3 class="d-flex"><img src="../../../../static/website/images/u_heart-sign.svg" alt=""> Blood
                                                        Pressure</h3>
                                                    <p>Assigned 7 days ago</p>
                                                    <h4 class="heart-sign">120/80 </h4>
                                                    <p>5 hours ago</p>
                                                    <p>May 23 09:00 AM</p>
                                                </a>
                                            </div>
                                            <div class="col p-4 Wearable-info border-right ">
                                                <a href="#">
                                                    <h3 class="d-flex"><img src="../../../../static/website/images/u_heart-rate.svg" alt=""> Heart Beat
                                                    </h3>
                                                    <p>Assigned 7 days ago</p>
                                                    <h4 class="heart-rate">76 </h4>
                                                    <p>5 hours ago</p>
                                                    <p>May 23 09:00 AM</p>
                                                </a>
                                            </div>
                                            <div class="col p-4 Wearable-info border-right ">
                                                <router-link to="sleep">
                                                    <h3 class="d-flex"><img src="../../../../static/website/images/u_bed.svg" alt=""> Sleep</h3>
                                                    <p>Assigned 7 days ago</p>
                                                    <h4 class="sleep-sign">6hr 20min</h4>
                                                    <p>5 hours ago</p>
                                                    <p>May 23 09:00 AM</p>
                                                </router-link>
                                            </div>
                                            <div class="col p-4 Wearable-info border-right ">
                                                <a href="#">
                                                    <h3 class="d-flex"><img src="../../../../static/website/images/scale.svg" alt=""> Weight</h3>
                                                    <p>Assigned 7 days ago</p>
                                                    <h4 class="weight-sign">80kg</h4>
                                                    <p>5 hours ago</p>
                                                    <p>May 23 09:00 AM</p>
                                                </a>
                                            </div>
                                            <div class="col p-4 Wearable-info ">
                                                <a href="#">
                                                    <h3 class="d-flex"><img src="../../../../static/website/images/footprints.svg" alt=""> Steps</h3>
                                                    <p>Assigned 7 days ago</p>
                                                    <h4 class="steps-sign">4,360 <span>Steps</span></h4>
                                                    <p>5 hours ago</p>
                                                    <p>May 23 09:00 AM</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="tab-pane " id="tracker" role="tabpanel">
                                <div class="row p-4">
                                    <div class="col-md-3 mb-4 card border-0 ">
                                        <div
                                            class="card-body border-0 bg-body border-radius-5 p-0 shop-product gini-product">
                                            <figure class="mb-0 p-3"><img src="../../../../static/website/images/fitness-band.png" alt=""></figure>
                                            <div class="text-center  px-3 pb-3">
                                                <h2>Ginis Fitness band/Bracelet</h2>
                                                <h3>US$ 179.95</h3>
                                                <ul class="d-flex my-3 justify-content-center rating">
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                </ul>
                                                <p>Health on Your Wrist</p>
                                                <div class="button mt-4 mb-4">
                                                    <router-link to="health-single-product" class="btn btn-blue click-here">Buy Now</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 mb-4 card border-0 ">
                                        <div
                                            class="card-body border-0 bg-body border-radius-5 p-0 shop-product gini-product">
                                            <figure class="mb-0 p-3"><img src="../../../../static/website/images/blood-pressure.png" alt=""></figure>
                                            <div class="text-center px-3 pb-3">
                                                <h2>Blood Pressure Monitor</h2>
                                                <h3>US$ 179.95</h3>
                                                <ul class="d-flex my-3 justify-content-center rating">
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                </ul>
                                                <p>Best for: Keeping an eye on blood pressure levels without a doctor.</p>
                                                <div class="button mt-4 mb-4">
                                                    <router-link to="health-single-product" class="btn btn-blue click-here">Buy Now</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 mb-4 card border-0 ">
                                        <div
                                            class="card-body border-0 bg-body border-radius-5 p-0 shop-product gini-product">
                                            <figure class="mb-0 p-3"><img src="../../../../static/website/images/glucose-monitor.png" alt=""></figure>
                                            <div class="text-center  px-3 pb-3">
                                                <h2>Continuous Glucose Monitor</h2>
                                                <h3>US$ 179.95</h3>
                                                <ul class="d-flex my-3 justify-content-center rating">
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                </ul>
                                                <p>Best for: Keeping an eye on blood pressure levels without...</p>
                                                <div class="button mt-4 mb-4">
                                                    <router-link to="health-single-product" class="btn btn-blue click-here">Buy Now</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 mb-4 card border-0 ">
                                        <div
                                            class="card-body border-0 bg-body border-radius-5 p-0 shop-product gini-product">
                                            <figure class="mb-0 p-3"><img src="../../../../static/website/images/body-black.png" alt=""></figure>
                                            <div class="text-center px-3 pb-3">
                                                <h2>Weight Scale</h2>
                                                <h3>US$ 179.95</h3>
                                                <ul class="d-flex my-3 justify-content-center rating">
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                    <li><a href="#"><i class="icon icon-star "></i></a></li>
                                                </ul>
                                                <p>Best for: Keeping an eye on blood pressure levels without a doctor.</p>
                                                <div class="button mt-4 mb-4">
                                                    <router-link to="health-single-product" class="btn btn-blue click-here">Buy Now</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane gini-orders" id="orders" role="tabpanel">
                                <div class="row no-gutters p-4">
                                    <div class="col-md-12 mb-4 ">
                                        <h2 class="your-order">Your Orders</h2>
                                    </div>
                                    <div class="col-md-12 mb-4 border-bottom pb-4">
                                        <div class="d-flex justify-content-between">
                                            <div class="health-left d-flex justify-content-between align-items-center">
                                                <figure class="mb-0"><img src="../../../../static/website/images/dna-image.png"></figure>
                                                <div class="product-name pl-4">
                                                    <h2>Gini DNA Kit</h2>
                                                    <p>Decode your gene-health- nutrition relationship</p>
                                                </div>
                                            </div>
                                            <div class="health-right d-flex justify-content-between align-items-center">
                                                <h5 class="cart mr-4">$45.95</h5>
                                                <a href="#" class="icon-order"><i class="icon icon-close"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-4 border-bottom pb-4">
                                        <div class="d-flex justify-content-between">
                                            <div class="health-left d-flex justify-content-between align-items-center">
                                                <figure class="mb-0"><img src="../../../../static/website/images/dna-image.png"></figure>
                                                <div class="product-name pl-4">
                                                    <h2>Gini DNA Kit</h2>
                                                    <p>Decode your gene-health- nutrition relationship</p>
                                                </div>
                                            </div>
                                            <div class="health-right d-flex justify-content-between align-items-center">
                                                <h5 class="cart mr-4">$45.95</h5>
                                                <a href="#" class="icon-order"><i class="icon icon-close"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-4 border-bottom pb-4">
                                        <div class="d-flex justify-content-between">
                                            <div class="health-left d-flex justify-content-between align-items-center">
                                                <figure class="mb-0"><img src="../../../../static/website/images/dna-image.png"></figure>
                                                <div class="product-name pl-4">
                                                    <h2>Gini DNA Kit</h2>
                                                    <p>Decode your gene-health- nutrition relationship</p>
                                                </div>
                                            </div>
                                            <div class="health-right d-flex justify-content-between align-items-center">
                                                <h5 class="cart mr-4">$45.95</h5>
                                                <a href="#" class="icon-order"><i class="icon icon-close"></i></a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12 ">
                                        <div class="d-flex justify-content-between">
                                            <div class="health-left d-flex justify-content-between align-items-center">
                                                <figure class="mb-0"><img src="../../../../static/website/images/dna-image.png"></figure>
                                                <div class="product-name pl-4">
                                                    <h2>Gini DNA Kit</h2>
                                                    <p>Decode your gene-health- nutrition relationship</p>
                                                </div>
                                            </div>
                                            <div class="health-right d-flex justify-content-between align-items-center">
                                                <h5 class="cart mr-4">$45.95</h5>
                                                <a href="#" class="icon-order"><i class="icon icon-close"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
        name: 'Health-Tracker',

    }
</script>


// WEBPACK FOOTER //
// src/components/website/health_tracker/health-tracker.vue